<div class="container-fluid">
    <div class="card card-outline-primary">
        <div class="card panel-default">
            <!--page Header-->
            <div class="card-header header-style text-center">
                <h6>
                    {{ 'ResidenceDegree' | translate }}<i class="fa fa-plus fa-1x icons-style"
                                                          aria-hidden="true" placement="left"
                                                          ngbTooltip="{{ 'ADD' | translate }}"
                                                          [routerLink]="[ 'new' ]"></i>
                </h6>
            </div>
            <!--search area-->
            <!--<div class="ui-widget-header search-area">
                <i class="fa fa-search search-icon"></i>
                <input #gb type="text" pInputText size="30" placeholder="{{ 'FILTER' | translate }}">
            </div>-->
          <div class="col-sm-3">
            <sanabel-selectize appcode="1093"
                               (clicked)="onSearchClick($event)"></sanabel-selectize>
          </div>
            <!--table area-->
            <!--header for column name & field for column content-->
            <p-dataTable tableStyleClass="table table-bordered table-striped" [value]="residenceDegree"
                         [rows]="10" [paginator]="true" [pageLinks]="3"
                         [rowsPerPageOptions]="[5,10,20,50,100]" >
                <p-column field="serial" header="{{ 'CODE' | translate }}" [sortable]="true"></p-column>
                <p-column field="degreeNameAr" header="{{ 'ARABICNAME' | translate }}"></p-column>
              <p-column field="degreeNameEn" header="{{ 'ENGLISHNAME' | translate }}"></p-column>
              <p-column field="limitByHour" header="{{ 'LIMITBYHOUR' | translate }}"></p-column>
              <p-column field="limitTypeAr" header="{{ 'LIMITTYPE' | translate }}"></p-column>
              <p-column field="resTypeAr" header="{{ 'RESTYPE' | translate }}"></p-column>
              <!--<p-column field="resType" header="{{ 'RESTYPE' | translate }}"></p-column>
              <p-column field="resBillItemCode" header="{{ 'RESBILLITEMCODE' | translate }}"></p-column>-->
                <p-column styleClass="col-button">
                    <ng-template pTemplate="options" let-row="rowData">
                        <icon-action (clicked)="onRowIconClick($event , row)" [appCodes]="[402,403]"></icon-action>
                    </ng-template>
                </p-column>
            </p-dataTable>
        </div>
    </div>
</div>
